import React from "react";
import { Result, Button, Image } from "antd";
import { env } from "@dt/util";

export default function ({ showExtra = true, subTitle = "抱歉，您没有当前页面权限" }) {
    const { systemPath } = env;
    const extra = [
        <Button type="primary" key={"goHome"} onClick={() => (location = `${location.origin}/${systemPath}/`)}>
            返回首页
        </Button>,
    ];
    return (
        <div style={{ height: "100%", width: "100%" }}>
            <Result
                style={{ marginTop: 132 }}
                subTitle={subTitle}
                icon={
                    <img
                        width={269}
                        height={207}
                        src={"https://dante-img.oss-cn-hangzhou.aliyuncs.com/5279490577.png"}
                    />
                }
                extra={showExtra && extra}
            />
        </div>
    );
}
